// extracted by mini-css-extract-plugin
module.exports = {"additional-message":"additional-messages_additional-message___X5xA"};